import {ServerTablePrintOrientation, ServerTablePrintTextSize} from "./types";

export const PRINT_PAGE_PADDING = 30;
export const PRINT_PAGE_SIZES: Record<ServerTablePrintOrientation, {width: number; height: number}> = {
    portrait: {width: 793, height: 1122},
    landscape: {width: 1122, height: 793}
};

export const PRINT_TEXT_SIZES: Record<ServerTablePrintTextSize, number> = {
    compact: 11,
    standard: 13,
    large: 15
};

// Printed pages use fixed ink colors regardless of the application theme.
export const PRINT_INK = {
    text: '#1F2937',
    muted: '#64748B',
    border: '#D8E0EA',
    rowBorder: '#E7ECF2',
    headerBg: '#F6F8FB'
};

export const MIN_PRINT_COLUMN_WIDTH = 48;
export const ADDITIONAL_NOTES_COLUMN_ID = '__additional_notes';
export const ADDITIONAL_NOTES_COLUMN_WIDTH = 260;
export const PRINT_CONFIG_STORAGE_PREFIX = 'serverTablePrint:v2:';
